import type { TradesPageFilters } from './tradesFilters';

export default function ActiveFilterChips({
  liveFilters,
  marketFilter,
  onClearSearch,
  onClearMarket,
  onClearSide,
  onClearTimeframe,
  onClearAll,
}: {
  liveFilters: TradesPageFilters;
  marketFilter: 'ALL' | 'STOCKS' | 'FUTURES' | 'FOREX' | 'CRYPTO';
  onClearSearch: () => void;
  onClearMarket: () => void;
  onClearSide: () => void;
  onClearTimeframe: () => void;
  onClearAll: () => void;
}) {
  const hasSearchTerm = (liveFilters.searchTerm ?? '').trim().length > 0;

  return (
    <div className="mt-2 px-2 flex items-center gap-2 flex-wrap" data-testid="active-chips">
      {liveFilters.searchTerm ? (
        <div data-testid="chip-search" className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-zinc-100 dark:bg-zinc-800 text-sm">
          <span className="font-semibold">Search:</span>
          <span className="truncate max-w-[18rem]">{liveFilters.searchTerm}</span>
          <button onClick={onClearSearch} aria-label="clear-search" className="ml-2 text-zinc-500">✕</button>
        </div>
      ) : null}

      {hasSearchTerm && marketFilter && marketFilter !== 'ALL' ? (
        <div data-testid="chip-market" className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-zinc-100 dark:bg-zinc-800 text-sm">
          <span className="font-semibold">Market:</span>
          <span>{marketFilter}</span>
          <button onClick={onClearMarket} aria-label="clear-market" className="ml-2 text-zinc-500">✕</button>
        </div>
      ) : null}

      {liveFilters.sideFilter && liveFilters.sideFilter !== 'All' ? (
        <div data-testid="chip-side" className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-zinc-100 dark:bg-zinc-800 text-sm">
          <span className="font-semibold">Side:</span>
          <span>{liveFilters.sideFilter}</span>
          <button onClick={onClearSide} aria-label="clear-side" className="ml-2 text-zinc-500">✕</button>
        </div>
      ) : null}

      {(() => {
        const tf = liveFilters.timeframe;
        if (tf && tf !== 'alltime') {
          if (tf === 'custom') {
            const from = liveFilters.fromDate ?? '';
            const to = liveFilters.toDate ?? '';
            const text = from && to ? `${from} → ${to}` : 'Custom';
            return (
              <div data-testid="chip-time" className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-zinc-100 dark:bg-zinc-800 text-sm">
                <span className="font-semibold">Time:</span>
                <span>{text}</span>
                <button onClick={onClearTimeframe} aria-label="clear-time" className="ml-2 text-zinc-500">✕</button>
              </div>
            );
          }
          return (
            <div data-testid="chip-time" className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-zinc-100 dark:bg-zinc-800 text-sm">
              <span className="font-semibold">Time:</span>
              <span>{tf}</span>
              <button onClick={onClearTimeframe} aria-label="clear-time" className="ml-2 text-zinc-500">✕</button>
            </div>
          );
        }
        return null;
      })()}

      {hasSearchTerm ? (
        <button
          data-testid="chip-clear-all"
          onClick={onClearAll}
          className="ml-2 inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-zinc-100 dark:bg-zinc-800 text-sm text-zinc-700 dark:text-zinc-200 border border-zinc-200 dark:border-zinc-700"
        >
          CLEAR
        </button>
      ) : null}
    </div>
  );
}
